import { render, staticRenderFns } from "./compareNew.vue?vue&type=template&id=5682508d&scoped=true"
import script from "./compareNew.vue?vue&type=script&lang=js"
export * from "./compareNew.vue?vue&type=script&lang=js"
import style0 from "./compareNew.vue?vue&type=style&index=0&id=5682508d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5682508d",
  null
  
)

export default component.exports